import Dropdown from 'styleguide/components/dropdown'

export default function LanguageSelector(el, location) {
  this._location = location

  this._dropdown = new Dropdown(el.querySelector('.wz-dropdown'))

  el.querySelector('.wz-dropdown__close-button').addEventListener('click', e => {
    e.preventDefault()
    this._dropdown.close()
  })

  el.querySelector('.wz-dropdown__menu').addEventListener('click', e => {
    if (e.target.tagName !== 'A') return
    e.preventDefault()
    this._dropdown.close()

    const code = e.target.dataset.locale
    const text = e.target.innerText

    el.querySelector('.wz-dropdown__button span').innerText = text
    this._location.set('locale', code, { parse: true })
  })
}

LanguageSelector.initialize = location => {
  const el = document.querySelector('.wz-language-selector')
  if (el != null) {
    new LanguageSelector(el, location)
  }
}
